module.exports = __webpack_public_path__ + "res/7-img_game_bg_q_m.e62a963a9e5edc3009f285823b228efc.png";